import { db } from "@/firebaseConfig";

const scheduleDrinksCollection = db.collection("schedule_drinks");

const saveScheduleDrink = async (id, data) => {
  scheduleDrinksCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("ScheduleDrink successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateScheduleDrink = async (id, data) => {
  scheduleDrinksCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("ScheduleDrink successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteScheduleDrink = async id => {
  scheduleDrinksCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("ScheduleDrink successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getScheduleDrinkById = async id => {
  return scheduleDrinksCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  scheduleDrinksCollection,
  saveScheduleDrink,
  updateScheduleDrink,
  deleteScheduleDrink,
  getScheduleDrinkById
};
